import { UiSchema } from '../form/rjsf'

export const sampleFilterUiSchema: UiSchema = {
  status: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  result: {
    'ui:hideOptionalLabel': true
  },
  productIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  matrixIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  substanceIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  fromDate: {
    'ui:widget': 'selectDueDateWidget',
    'ui:hideOptionalLabel': true
  },
  toDate: {
    'ui:widget': 'selectDueDateWidget',
    'ui:hideOptionalLabel': true
  },
  sampntTypeIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  producerSearch: {
    'ui:hideOptionalLabel': true,
    'ui:placeholder': 'Søk på produsentnavn eller nummer'
  },
  planIds: {
    'ui:widget': 'multiSelectWidget',
    'ui:hideOptionalLabel': true
  },
  ownerId: {
    'ui:hideOptionalLabel': true
  },
  regionId: {
    'ui:hideOptionalLabel': true
  },
  avdelingId: {
    'ui:hideOptionalLabel': true
  },
  seksjonId: {
    'ui:hideOptionalLabel': true
  },
  teamId: {
    'ui:hideOptionalLabel': true,
    'ui:options': {
      placement: 'top'
    }
  }
}
